<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de création d'une notification</h2>
          <template>
            <v-form ref="form">
              <!-- titre -->
              <v-text-field
                v-model="notification.title"
                :counter="150"
                label="Titre de la notification *"
                required
                :rules="[rules.required]"
              ></v-text-field>
              
              <hr style="width: 30%; margin: auto; margin-top: 2%; margin-bottom: 2%;"/>

              <!-- Type -->
              <v-combobox v-model="notification.type" :items= "typeItems" label="Type de notification *"/>
              
              <hr style="width: 30%; margin: auto; margin-top: 2%; margin-bottom: 3%;"/>

              <!-- Description -->
              <v-textarea
                v-model="notification.description"
                :counter="250"
                label="Description *"
                required
                outlined
                :rules="[rules.required]"
                @keydown="limitTextLength"
              ></v-textarea>

              <hr style="width: 30%; margin: auto; margin-top: 2%; margin-bottom: 2%;"/>

              <!-- Choix d'utilisateurs -->
              <h4 style="margin-left: 4%; margin-bottom: 3%;">Destinataires de la notification * </h4>
              <v-radio-group v-model="choiceUser" row>
                <v-radio label="Tous les utilisateurs" value="all"></v-radio>
                <v-radio label="Utilisateurs spécifiques" value="specific"></v-radio>
              </v-radio-group>

              <!-- Options pour utilisateurs spécifiques -->
              <div v-if="choiceUser == 'specific'" class="mt-4">
                <v-radio-group style="margin-left: 27%;" v-model="specificType" row>
                  <v-radio label="Par droit" value="userRights"></v-radio>
                  <v-radio label="Par clients" value="clients"></v-radio>
                  <v-radio label="Par outils" value="tools"></v-radio>
                  <v-radio label="Par utilisateurs" value="users"></v-radio>
                </v-radio-group>

                <!-- Par droits -->
                <div v-if="specificType == 'userRights'" class="mt-4">
                  <v-combobox
                    v-model="notification.userRights"
                    :items="rightsItems"
                    item-key="id"
                    item-text="name"
                    label="Sélectionner les droits"
                    multiple
                  ></v-combobox>
                </div>

                <!-- Par clients -->
                <div v-if="specificType == 'clients'" class="mt-4">
                  <v-combobox
                    v-model="notification.clients"
                    :items="clientsItems"
                    item-key="id"
                    item-text="name"
                    label="Sélectionner les clients"
                    multiple
                  ></v-combobox>
                </div>

                <!-- Par Outils -->
                <div v-if="specificType == 'tools'" class="mt-4">
                  <v-combobox
                    v-model="notification.tools"
                    :items="toolsItems"
                    item-key="id"
                    item-text="title"
                    label="Sélectionner les outils"
                    multiple
                  ></v-combobox>
                </div>

                <!-- Par Utilisateurs -->
                <div v-if="specificType == 'users'" class="mt-4">
                  <v-combobox
                    v-model="notification.users"
                    :items="usersItems"
                    item-key="id"
                    :item-text="formatUserText"
                    label="Sélectionner les utilisateurs"
                    multiple
                  ></v-combobox>
                </div>
              </div>

              <v-btn class="float-right" color="primary" @click="submit">
                Valider
              </v-btn>
            </v-form>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "notificaionManagement",
  data: () => ({
    notification: {
      title: "",
      description: "",
      type: "INFO",
      userRights: [],
      clients: [],
      tools: [],
      users: [],
    },
    typeItems: ["INFO", "WARNING", "ERROR"],
    choiceUser: "all",
    specificType: null,
    rightsItems: [],
    clientsItems: [],
    toolsItems: [],
    usersItems: [],
    rules: {
      required: value => !!value || "Ce champ est requis",
    },
  }),

  
  methods: {
    formatUserText(user) {
      return `${user.firstname} ${user.lastname} (${user.email})`
    },

    limitTextLength(event) {
      if (this.notification.description.length >= 250 && event.key !== "Backspace" && event.key !== "Delete") {
        event.preventDefault();
      }
    },

    getAllItems(){
      Api.post("getItemsForNotification").then((response) => {
        this.usersItems = response.data.usersItems;
        this.rightsItems = response.data.rightsItems;
        this.clientsItems = response.data.clientsItems;
        this.toolsItems = response.data.toolsItems;
      })
    },

    submit: async function() {
      const isFormValid = this.$refs.form.validate();
      if(isFormValid){
        try{
          const filter = {titleNotif: this.notification.title, typeNotif: this.notification.type, descriptionNotif: this.notification.description};
          if(this.choiceUser == 'all'){
            filter.choiceAllUsers = true;
          }else if (this.specificType == 'userRights'){
            filter.choiceUserRight = this.notification.userRights.map(right => right.id);
          }else if (this.specificType == 'clients'){
            filter.choiceClient = this.notification.clients.map(client => client.id);
          }else if (this.specificType == 'tools'){
            filter.choiceTheme = this.notification.tools.map(tool => tool.id);
          }else if (this.specificType == 'users'){
            filter.choiceSpecificUsers = this.notification.users.map(user => user.id);
          }

          Api.post('newNotification', filter).then((response) => {
            this.notification = {
              title: "",
              description: "",
              type: "INFO",
              userRights: [],
              clients: [],
              tools: [],
              users: [],
            };
            this.choiceUser = "all";
            this.specificType = null;
            this.$refs.form.resetValidation();
            if(response.data.nbError > 0){
              Swal.fire({
                title: "",
                text: `Les notifications ont été créées avec succès, sauf pour ${response.data.nbError} utilisateur(s). Pour plus de détails, veuillez contacter un administrateur.`,
                icon: "success",
                confirmButtonClass: "btn btn-secondary",
              });
            }else{
              Swal.fire({
                title: "",
                text: "Les notifications été créés avec succès",
                icon: "success",
                confirmButtonClass: "btn btn-secondary",
              });
            }
            
          }).catch((e) => {
            console.log(e);
            Swal.fire({
              title: "",
              text: "Une erreur s'est produite lors de la création de la notification. Veuillez contacter un administrateur.",
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
            });
          });
          
        }catch (error) {
          Swal.fire({
            title: "",
            text: "Une erreur est survenue lors de la création de la notification. Veuillez contacter un administrateur.",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          return;
        }
      }
    },
  },

  watch: {
    specificType(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.notification.userRights = [];
        this.notification.clients = [];
        this.notification.tools = [];
      }
    },
  },
  
  mounted() {
    this.getAllItems();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration"},
      { title: "Gestion des notification", route: "gestionNotfications" },
      { title: "Ajouter une notification" },
    ]);
  },
};
</script>
